import React from 'react';
import Markdown from 'markdown-to-jsx';

import * as S from './styles';

interface Props {
  content: string;
}

export function MarkdownRenderer({ content }: Props) {
  return (
    <S.Container>
      <Markdown options={{ forceBlock: true }}>{content}</Markdown>
    </S.Container>
  );
}
